import React, { useMemo } from 'react';

import GenericAsyncSelect from 'src/views/components/select/GenericAsyncSelect';

const createLoadOptions = (sources) => {
  return async filter => {
    const optionsPromise = sources
      .map(async s => ({
        label: s.label,
        options: await s.loadOptions(filter)
      }));
    let options = await Promise.all(optionsPromise);
    if (options.length === 1) options = options[0].options;
    return options;
  };
};

const BaseAdditionalValueSelector = ({ optionSources, ...props }) => {
  const loadOptions = useMemo(() => createLoadOptions(optionSources), [optionSources]);
  return (
    <GenericAsyncSelect
      loadOptions={loadOptions}
      {...props}
    />
  );
};

export default BaseAdditionalValueSelector;
